
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    weapon: 'Weapon',
    sticker: 'Sticker',
    graffiti: 'Graffiti',
    case: 'Case',
    capsule: 'Capsule',
    package: 'Package',
    collection: 'Collection',
    musicKit: 'Music kit',
    patch: 'Patch',
    charm: 'Charm',
    agent: 'Agent',
    knife: 'Knife',
    gloves: 'Gloves',
    item: 'Item',
    condition: 'Condition',
    color: 'Color',
  },
  ru: {
    weapon: 'Оружие',
    sticker: 'Стикер',
    graffiti: 'Граффити',
    case: 'Кейс',
    capsule: 'Капсула',
    package: 'Набор',
    collection: 'Коллекция',
    musicKit: 'Музыкальный набор',
    patch: 'Нашивка',
    charm: 'Брелок',
    agent: 'Агент',
    knife: 'Нож',
    gloves: 'Перчатки',
    item: 'Предмет',
    condition: 'Состояние',
    color: 'Цвет',
  },
  uz: {
    weapon: 'Qurol',
    sticker: 'Stiker',
    graffiti: 'Grafitti',
    case: 'Quti',
    capsule: 'Kapsula',
    package: 'Toplam',
    collection: 'Kolleksiya',
    musicKit: 'Musiqa toplami',
    patch: 'Yamoq',
    charm: 'Brelok',
    agent: 'Agent',
    knife: 'Pichoq',
    gloves: 'Qo\'lqop',
    item: 'Buyum',
    condition: 'Holati',
    color: 'Rang',
  },
});
